module.exports = __webpack_public_path__ + "static/media/image-01-full.81efb168.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-01-full.jpg
// module id = 345
// module chunks = 0